import React from "react";
import { Route, Redirect } from "react-router-dom";
import useAuth from "hooks/useAuth";
import { APP_PREFIX_PATH } from "configs/AppConfig";

/**
 * PublicRoute - Guards routes meant for signed-out users (e.g. /auth/login).
 * If the user is already authenticated, skip straight to the app instead of
 * showing the login form.
 */
export const PublicRoute = (props) => {
  const { isAuthenticated } = useAuth([]);

  if (isAuthenticated) {
    return <Redirect to={APP_PREFIX_PATH} />;
  }

  return <Route {...props}>{props.children}</Route>;
};

export default PublicRoute;
